import {Component, Input, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {Project} from "../../shared/models/project";
import {SizeService} from "../../shared/services/size.service";
import {Size} from "../../shared/models/size";
import {SizeRange} from "../../shared/models/sizeRange";

@Component({
    selector: 'mbnm-opening-size-calculator-dialog',
    templateUrl: './opening-size-calculator-dialog.component.html',
    styleUrls: ['./opening-size-calculator-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class OpeningSizeCalculatorDialogComponent implements OnInit {

  constructor(private sizeService:SizeService) { }

  ngOnInit() {
    if (this.project.opening) {
      let fn = (item) => {
        let val = item.value + 0.5;
        return {
          value: val,
          text: val < 1 ? this.sizeService.fractionAsStringMultiChar(val) : this.sizeService.fractionAsString(val)
        };
      }

      let openingWRange = this.project.opening.size.widthRange;
      this.widthRange = new SizeRange(openingWRange.min + 0.5, openingWRange.max + 0.5, openingWRange.step);
      let openingHRange = this.project.opening.size.widthRange;
      this.heightRange = new SizeRange(openingHRange.min + 0.5, openingHRange.max + 0.5, openingHRange.step);

      this.artwork = new Size(this.project.opening.size.width + 0.5, this.project.opening.size.height + 0.5)
    }
  }

  @Input()
  project:Project;

  widthRange:SizeRange;
  heightRange:SizeRange;

  artwork:Size;

  get opening():Size {
    return new Size(this.artwork.width - 0.5, this.artwork.height - 0.5);
  }
}
